import BaseServiceCrud from './BaseServiceCrud';

export default class ReportsService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'reports';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    getTransactionReportAvailableColumns() {
        return this.fetch(`${this.domain}/${this.path}/transaction-report-available-columns`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }

    generateReport(element) {
        let selectedColumns = [];
        if (element?.columns && element?.columns?.length) {
            element?.columns.forEach((col) => {
                selectedColumns.push(col.value);
            });
        }
        return this.fetch(`${this.domain}/${this.path}/generate-report`, {
            method: 'POST',
            body: JSON.stringify({
                dateFrom: element.dateFrom,
                dateTo: element.dateTo,
                columns: selectedColumns,
                format: element.format,
                saveAsTemplate: element.saveAsTemplate,
                templateName: element.templateName,
            }),
        }).then((res) => {
            selectedColumns = [];
            return Promise.resolve(res);
        });
    }

    downloadReports(reportIds) {
        return this.fetch(
            `${this.domain}/${this.path}/download-reports`,
            {
                method: 'POST',
                body: JSON.stringify({ reports: reportIds }),
            },
            {
                Accept: 'application/zip',
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cahce',
            }
        ).then((res) => {
            return Promise.resolve(res);
        });
    }

    getReportTemplateList() {
        return this.fetch(`${this.domain}/${this.path}/templates-list`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }
    getReportTemplateListDetails() {
        return this.fetch(`${this.domain}/${this.path}/templates-list-details`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }

    getTemplateData(id) {
        return this.fetch(`${this.domain}/${this.path}/template/${id}`, {
            method: 'GET',
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }

    editTemplate(element) {
        let selectedColumns = [];
        if (element?.columns && element?.columns?.length) {
            element?.columns.forEach((col) => {
                selectedColumns.push(col.value);
            });
        }
        return this.fetch(`${this.domain}/${this.path}/template/${element.id}`, {
            method: 'PUT',
            body: JSON.stringify({
                id: element.id,
                cbkId: element.cbkId,
                columns: selectedColumns,
                format: element.format,
                templateName: element.templateName,
            }),
        }).then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }

    removeTemplate(elementId) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/template/${elementId}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    validateTemplateName(name, id) {
        if(id === undefined){
            id = 0;
        }
        return this.fetch(`${this.domain}/${this.path}/template/validate/${id}/${name}`, {
            method: 'GET',
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }

}
